function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.917 1.167v1.166h-.584V10.5a2.333 2.333 0 01-4.666 0V2.333h-.584V1.167h5.834zM7.583 8.75a.583.583 0 100 1.167.583.583 0 000-1.167zM6.417 7a.583.583 0 100 1.167.583.583 0 000-1.167zm1.75-4.667H5.833v2.334h2.334V2.333z",
  fill: "currentColor"
});

var SvgLabTube = function SvgLabTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgLabTube;